<template>
  <div style="padding: 20px;">
    <div style="display: flex; justify-content: space-between; flex-wrap: wrap;">
      <div class="scale-selector">
        <div class="scale-selector-day active">
          Jour
        </div>
        <div class="scale-selector-week" @click="gotoWeeklyMenu">
          Semaine
        </div>
      </div>

      <div class="day-selector">
        <div class="day-selector-arrow" @click="gotoPreviousDay">
          <font-awesome-icon class="icon" :icon="['fas', 'chevron-left']" />
        </div>
        <div class="day-selector-previous-day">
          {{ humanizeDate(removeDay(date)) }}
        </div>
        <div class="day-selector-current-day">
          {{ humanizeDate(date) }}
        </div>
        <div class="day-selector-next-day">
          {{ humanizeDate(addDay(date)) }}
        </div>
        <div class="day-selector-arrow" @click="gotoNextDay">
          <font-awesome-icon class="icon" :icon="['fas', 'chevron-right']" />
        </div>
      </div>

      <div class="scale-selector" style="visibility: hidden;">
        <div class="scale-selector-day">
          Jour
        </div>
        <div class="scale-selector-week active">
          Semaine
        </div>
      </div>
    </div>

    <div style="margin-top: 20px;">
      <LoaderView v-if="menu == 'loading' || menu == null"></LoaderView>

      <div v-else-if="menu == 'error'">
        <font-awesome-icon class="icon" :icon="['fas', 'exclamation-triangle']" />
      </div>

      <div v-else-if="menu == 'consumer_profil_not_available'">
        Vous n'avez pas encore rempli votre profil de meilleur mangeur
      </div>

      <div v-else-if="menu == 'not_yet_available'">
        Nous n'avons pas encore décidé de votre menu pour ce jour
      </div>

      <div v-else class="menu-container">
        <div v-for="(card, index) in displayCards" :key="`${card.type}-${card.meal || card.item?.id || index}`">
          <MenuItemCard v-if="card.type === 'item'" :item="card.item" :date="date.toISOString().split('T')[0]"
            @update="updateMenuItem" />

          <div v-else-if="card.type === 'outside'" class="outside-card">
            <img :src="burgerImage" alt="Repas à l'extérieur" class="outside-card-image" />

            <div class="outside-card-meal">
              {{ card.label }}
            </div>

            <div class="outside-card-name">
              Repas à l'extérieur
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="bottom-cards">
      <MyPdf />

      <MyLikedDishes />

      <div class="card green">
        <div class="form-title">
          Mes apports nutritionnels
        </div>
        <div class="card light-green clickable" @click="gotoApports">
          <div class="liked-dish-name">
            Voir mes apports nutritionnels
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { api } from "@/api";
import LoaderView from "@/components/LoaderView.vue";
import MyLikedDishes from "@/views/MyLikedDishes.vue";
import MenuItemCard from "@/components/MenuItemCard.vue";
import MyPdf from "@/views/MyPdf.vue";

export default {
  name: "MyMenusDay",
  components: {
    LoaderView,
    MyLikedDishes,
    MenuItemCard,
    MyPdf,
  },
  data() {
    return {
      date: new Date(),
      menu: null,
      burgerImage: "/images/repas-exterieur.jpg",
    };
  },
  computed: {
    mainDishes() {
      if (this.menu == null || !this.menu.items) {
        return [];
      }
      return this.menu.items.filter(item =>
        ["lunch_main", "diner_main", "breakfast", "snack"].includes(item.dish_type)
      );
    },
    displayCards() {
      if (!this.menu || !this.menu.items) {
        return [];
      }

      const cards = [];
      const items = [...this.menu.items];

      const breakfast = items.find(item => item.dish_type === "breakfast");
      const lunchStarter = items.find(item => item.dish_type === "lunch_starter");
      const lunchMain = items.find(item => item.dish_type === "lunch_main");
      const snack = items.find(item => item.dish_type === "snack");
      const dinnerStarter = items.find(item => item.dish_type === "diner_starter");
      const dinnerMain = items.find(item => item.dish_type === "diner_main");

      if (breakfast) {
        cards.push({ type: "item", item: breakfast });
      }

      if (this.menu.lunch_origin_type === "outside") {
        cards.push({ type: "outside", meal: "lunch", label: "Déjeuner" });
      } else {
        if (lunchStarter) {
          cards.push({ type: "item", item: lunchStarter });
        }
        if (lunchMain) {
          cards.push({ type: "item", item: lunchMain });
        }
      }

      if (snack) {
        cards.push({ type: "item", item: snack });
      }

      if (this.menu.dinner_origin_type === "outside") {
        cards.push({ type: "outside", meal: "dinner", label: "Dîner" });
      } else {
        if (dinnerStarter) {
          cards.push({ type: "item", item: dinnerStarter });
        }
        if (dinnerMain) {
          cards.push({ type: "item", item: dinnerMain });
        }
      }

      return cards;
    },
  },
  mounted() {
    this.loadMenu(this.date);
  },
  methods: {
    gotoPreviousDay() {
      this.date.setDate(this.date.getDate() - 1);
      this.loadMenu(this.date);
    },
    gotoNextDay() {
      this.date.setDate(this.date.getDate() + 1);
      this.loadMenu(this.date);
    },
    capitalizeFirstLetter(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    loadMenu(date) {
      this.menu = "loading";

      api.get(`my-menu/${date.toISOString().split("T")[0]}/`)
        .then(response => {
          if (date == this.date) {
            this.menu = response.data;
          }
        }).catch(error => {
          if (date == this.date) {
            if (error.response.status == 404) {
              this.menu = "not_yet_available";
            } else {
              this.menu = "error";
              throw error;
            }
          }
        });
    },
    humanizeDate(date) {
      return this.capitalizeFirstLetter(
        date.toLocaleDateString("fr-FR", { weekday: "long", day: "numeric" })
      );
    },
    addDay(date) {
      const nextDay = new Date(date);
      nextDay.setDate(date.getDate() + 1);
      return nextDay;
    },
    removeDay(date) {
      const previousDay = new Date(date);
      previousDay.setDate(date.getDate() - 1);
      return previousDay;
    },
    gotoMenuItem(item) {
      this.$router.push({ name: "my-menu-item", params: { id: item.id } });
    },
    gotoWeeklyMenu() {
      this.$router.push({ name: "my-menus" });
    },
    updateMenuItem(item) {
      this.menu.items = this.menu.items.map(i => {
        if (i.id == item.id) {
          return item;
        }
        return i;
      });
    },
    gotoApports() {
      this.$router.push({ name: "apports" });
    },
  },
};
</script>

<style scoped>
.day-selector {
  display: flex;
  justify-content: center;
  gap: 20px;
  align-items: center;
}

.day-selector-arrow {
  cursor: pointer;
  background: #436f0e;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
}

.day-selector-previous-day {
  font-size: 20px;
  font-family: "Amanise";
  font-weight: 500;
  color: #85a063;
}

.day-selector-current-day {
  font-size: 30px;
  font-family: "Amanise";
  font-weight: 500;
  color: #436f0e;
}

.day-selector-next-day {
  font-size: 20px;
  font-family: "Amanise";
  font-weight: 500;
  color: #85a063;
}

.menu-container {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}

.menu-item {
  background: white;
  padding: 20px;
  margin: 10px;
  width: 200px;
  min-width: 150px;
  height: 100%;
}

.menu-item-image {
  width: 100%;
  border-radius: 10px;
}

.menu-item-meal {
  font-size: 20px;
  font-weight: 800;
  color: #436f0e;
}

.menu-item-name {
  font-size: 15px;
}

.menu-item-bottom-bar {
  display: flex;
  justify-content: center;
  margin-top: auto;
  padding-top: 10px;
}

.scale-selector {
  display: flex;
  justify-content: center;
}

.scale-selector-day {
  font-size: 20px;
  font-family: "Amanise";
  font-weight: 500;
  color: #85a063;
  cursor: pointer;
  border: 1px solid #436f0e;
  border-right: none;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  padding: 10px;
  background: white;
}

.scale-selector-day.active {
  background: #436f0e;
  color: white;
  border: none;
}

.scale-selector-day:hover {
  background: #85a063;
  color: white;
  border: none;
}

.scale-selector-week {
  font-size: 20px;
  font-family: "Amanise";
  font-weight: 500;
  color: #85a063;
  cursor: pointer;
  border: 1px solid #436f0e;
  border-left: none;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  padding: 10px;
  background: white;
}

.scale-selector-week.active {
  background: #436f0e;
  color: white;
  border: none;
}

.scale-selector-week:hover {
  background: #85a063;
  color: white;
  border: none;
}

.liked-dish-name {
  font-size: 20px;
  font-weight: bold;
  color: #000;
  text-align: center;
  padding: 10px;
}

.bottom-cards {
  margin-top: 50px;
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}

.bottom-cards>* {
  flex: 1 1 300px;
  max-width: 100%;
}

.outside-card {
  background: white;
  padding: 20px;
  margin: 10px;
  width: 200px;
  min-width: 150px;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  height: 100%;
}

.outside-card-image {
  width: 100%;
  object-fit: cover;
}

.outside-card-meal {
  font-size: 20px;
  font-weight: 800;
  color: #436f0e;
  margin-top: 12px;
}

.outside-card-name {
  font-size: 15px;
  margin-top: 8px;
}
</style>